// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#external-events {\n  padding: 0 10px;\n  background: #eee;\n  text-align: left;\n}\n#external-events h4 {\n  font-size: 16px;\n  margin-top: 0;\n  padding-top: 1em;\n}\n#external-events .fc-event {\n  margin: 10px 0;\n  cursor: pointer;\n}\n#external-events p {\n  margin: 1.5em 0;\n  font-size: 11px;\n  color: #666;\n}\n#external-events p input {\n  margin: 0;\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
